import { cloneElement, createElement, isValidElement } from 'react'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createOrCloneElement = (element, props, children) =>
  isValidElement(element)
    ? cloneElement(element, props, children)
    : createElement(element, props, children)
